import {cc} from "@Common/react/callback-chain";

export const csArr = (arr:any[], next:any) => cc([], [
    ...arr.map((fn) =>
        (_, next) => fn((ret) => next([..._, ret]))
    ),
    next,
]);
